import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();
  const [detail, setDetail] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const fetchDetails = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get("/details/get-basic-details");
      setDetail(res.data.result);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    fetchDetails();
  }, []);
  return (
    <>
      <div className="mid-footer">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-3">
              <div className="footer-mid img-log d-flex align-items-center gap-2">
                <img src="assets/images/fav-logo-2.png" width="13px" />
                <span>The everything app, for work.</span>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="footer-mid  d-flex align-items-center gap-2">
                <img src="assets/images/support.png" width="26px" />
                <span>24/7 Support</span>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="footer-mid d-flex align-items-center gap-2">
                <img src="assets/images/weekly.png" width="26px" />
                <span>Weekly Updates</span>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="footer-mid d-flex align-items-center gap-2">
                <img src="assets/images/secure.png" width="26px" />
                <span>Secure and Compliant</span>
              </div>
            </div>
            {/* <div className="col-lg-3">
              <div className="footer-mid d-flex align-items-center gap-2">
                <img src="assets/images/uptime.png" width="26px" />
                <span>99.9% uptime</span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <footer className="footer aos aos-init aos-animate">
        <div className="footer-top">
          <div className="container">
            <div className="row row-gap-4">
              <div className="col-lg-4">
                <div className="footer-widget footer-menu">
                  <a className="logo-white footer-logo" href="index.html">
                    <img
                      src="assets/images/logo-black.png"
                      className="logo"
                      alt="Logo"
                    />
                  </a>
                  <p>
                    The all-in-one tool that empowers you to streamline your
                    business operations, improve productivity, and accelerate
                    growth by managing the sales pipeline effortlessly.
                  </p>
                </div>
                <div className="d-flex align-items-center mt-4">
                  <a
                    href="https://apps.apple.com/hr/app/clidex/id6746163461"
                    className="me-2"
                    target="_blank"
                  >
                    <img src="assets/images/app-store-badge-black.svg" alt="" />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.webmobril.lms.lms&hl=en"
                    target="_blank"
                    // rel="noopener noreferrer"
                    className="me-2"
                  >
                    <img
                      src="assets/images/google-play-badge-black.svg"
                      alt=""
                    />
                  </a>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="footer-widget footer-menu">
                  <h5 className="footer-title">Quick Links</h5>
                  <ul>
                    <li>
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/");
                          window.scrollTo(0, 0);
                        }}
                      >
                        Home{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/about-us");
                          window.scrollTo(0, 0);
                        }}
                      >
                        About Us
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/subscription");
                          window.scrollTo(0, 0);
                        }}
                      >
                        Pricing
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/blogs");
                          window.scrollTo(0, 0);
                        }}
                      >
                        Blog
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/contact-us");
                          window.scrollTo(0, 0);
                        }}
                      >
                        Contact Us
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/privacy-policy");
                          window.scrollTo(0, 0);
                        }}
                      >
                        Privacy Policy
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="footer-widget footer-menu">
                  <h5 className="footer-title">Contact </h5>
                  <ul>
                    <li>
                      <a> Email : {detail?.email}</a>
                    </li>
                    <li>
                      <a>
                        {" "}
                        Phone No : +{detail.isd}-{detail.phone}
                      </a>
                    </li>
                    {/* <li><a href="">Fax : 55533333</a></li> */}
                  </ul>
                  <div className="social-media-a mt-4">
                    <a
                      href="https://www.linkedin.com/company/clidex/?viewAsMember=true"
                      target="_blank"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={26}
                        height={26}
                        fill="none"
                        className="CuBottomNavigation_icon__ZwoJn"
                        aria-label="Follow Clidex on LinkedIn"
                      >
                        <rect
                          width={25}
                          height={25}
                          x="0.2"
                          y="0.061"
                          fill="var(--color-icon, #0D1530)"
                          rx="5.714"
                        />
                        <path
                          fill="#fff"
                          d="M8.699 9.88H5.68a.24.24 0 0 0-.243.242v9.696c0 .133.109.242.243.242h3.018a.24.24 0 0 0 .242-.242v-9.696a.24.24 0 0 0-.24-.242zM7.192 5.06A1.993 1.993 0 0 0 5.2 7.05c0 1.097.893 1.99 1.992 1.99 1.097 0 1.99-.893 1.99-1.99s-.893-1.99-1.99-1.99m9.184 4.58c-1.212 0-2.108.52-2.652 1.113v-.63a.24.24 0 0 0-.242-.242h-2.89a.24.24 0 0 0-.243.242v9.695c0 .134.108.243.242.243h3.012a.24.24 0 0 0 .242-.243v-4.797c0-1.616.44-2.246 1.566-2.246 1.227 0 1.325 1.01 1.325 2.33v4.713c0 .134.108.243.242.243h3.013a.24.24 0 0 0 .242-.243V14.5c0-2.403-.458-4.86-3.857-4.86"
                        ></path>
                      </svg>
                    </a>
                    <a
                      href="https://www.facebook.com/clidexofficial/"
                      target="_blank"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={26}
                        height={26}
                        fill="none"
                        className="CuBottomNavigation_icon__ZwoJn"
                        aria-label="Follow Clidex on Facebook"
                      >
                        <rect
                          width={25}
                          height={25}
                          x="0.2"
                          y="0.061"
                          fill="var(--color-icon, #0D1530)"
                          rx="5.714"
                        />
                        <path
                          fill="#fff"
                          d="M10.854 13.527H8.939c-.309 0-.406-.112-.406-.394v-2.271c0-.3.116-.395.406-.395h1.915V8.815c0-.75.135-1.464.522-2.121.406-.676.986-1.127 1.72-1.39a4.4 4.4 0 0 1 1.49-.243h1.894c.27 0 .387.112.387.375v2.14c0 .263-.116.376-.387.376-.522 0-1.044 0-1.566.018-.522 0-.793.244-.793.77-.02.563 0 1.108 0 1.69h2.243c.31 0 .425.112.425.413v2.271c0 .3-.096.395-.425.395h-2.243v6.12c0 .319-.096.431-.444.431H11.26c-.29 0-.406-.112-.406-.394z"
                        ></path>
                      </svg>
                    </a>
                    <a
                      href="https://www.instagram.com/clidexofficial/"
                      target="_blank"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={26}
                        height={26}
                        fill="none"
                        className="CuBottomNavigation_icon__ZwoJn"
                        aria-label="Follow Clidex on Instagram"
                      >
                        <path
                          fill="var(--color-icon, #0D1530)"
                          fillRule="evenodd"
                          d="M17.854.14c-2.3-.108-7.997-.103-10.299 0C5.533.233 3.748.721 2.31 2.16.158 4.313.178 7.134.206 11.107q.006.7.007 1.45-.001.7-.005 1.356C.185 18.019.17 20.81 2.31 22.95c2.155 2.155 5.006 2.133 8.935 2.104q.705-.006 1.46-.007h.067c4.764 0 6.42 0 8.114-.656 2.316-.9 4.064-2.969 4.235-6.687.108-2.3.102-7.996 0-10.298-.206-4.389-2.562-7.05-7.267-7.267zm3.774 5.873a1.786 1.786 0 1 1-3.571 0 1.786 1.786 0 0 1 3.571 0M12.7 17.322a4.762 4.762 0 1 0 0-9.524 4.762 4.762 0 0 0 0 9.524"
                          clipRule="evenodd"
                        />
                      </svg>
                    </a>
                    {/* <a href="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={26}
                        height={26}
                        fill="none"
                        className="CuBottomNavigation_icon__ZwoJn"
                        aria-label="Follow Clidex on Twitter"
                      >
                        <rect
                          width={25}
                          height={25}
                          x="0.2"
                          y="0.06"
                          fill="var(--color-icon, #0D1530)"
                          rx="5.714"
                        />
                        <path
                          fill="#fff"
                          d="m14.132 11.411 5.587-6.351h-1.324l-4.852 5.515L9.67 5.06H5.2l5.86 8.34-5.86 6.66h1.325l5.123-5.824 4.092 5.824h4.469l-6.079-8.65zm-1.814 2.062-.594-.83-4.723-6.609h2.033l3.812 5.333.594.83 4.955 6.932h-2.033z"
                        ></path>
                      </svg>
                    </a> */}
                  </div>
                  {/* <div className="social-media-a mt-4">
                    
                    <a>
                      <img
                        src="assets/images/linkedin.png"
                        alt=""
                        style={{ height: "26px" }}
                      />
                    </a>
                    <a>
                      <img
                        src="assets/images/facebook.png"
                        alt=""
                        style={{ height: "26px" }}
                      />
                    </a>
                    <a>
                      <img
                        src="assets/images/instagram.png"
                        alt=""
                        style={{ height: "26px" }}
                      />
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="footer-bottom">
          <div className="container">
            <div className="row row-gap-2 align-items-center">
              <div className="col-md-12">
                <div className="text-center">
                  <p className="">Copyright @2025 Clidex All Rights Reserved</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
